"use strict";

var _slicedToArray = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _regeneratorRuntime = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/createClass.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrollIntoView = exports.PuppeteerTestUtils = void 0;

var PuppeteerTestUtils = /*#__PURE__*/function () {
  function PuppeteerTestUtils(page) {
    _classCallCheck(this, PuppeteerTestUtils);

    this._page = page;
  }

  _createClass(PuppeteerTestUtils, [{
    key: "uploadFile",
    value: function () {
      var _uploadFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(filePath, options) {
        var _ref, index, elementHandles, _iterator, _step, elementHandle;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _ref = options || {}, index = _ref.index;
              _context.next = 3;
              return this.getElementsAtIndex("input[type=file]", index);

            case 3:
              elementHandles = _context.sent;

              if (elementHandles.length) {
                _context.next = 6;
                break;
              }

              throw new Error("Uploading failed: No input element found");

            case 6:
              _iterator = _createForOfIteratorHelper(elementHandles);
              _context.prev = 7;

              _iterator.s();

            case 9:
              if ((_step = _iterator.n()).done) {
                _context.next = 17;
                break;
              }

              elementHandle = _step.value;
              _context.next = 13;
              return elementHandle.uploadFile(filePath);

            case 13:
              _context.next = 15;
              return this.waitForElementEnabled(elementHandle, 45000);

            case 15:
              _context.next = 9;
              break;

            case 17:
              _context.next = 22;
              break;

            case 19:
              _context.prev = 19;
              _context.t0 = _context["catch"](7);

              _iterator.e(_context.t0);

            case 22:
              _context.prev = 22;

              _iterator.f();

              return _context.finish(22);

            case 25:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[7, 19, 22, 25]]);
      }));

      function uploadFile(_x, _x2) {
        return _uploadFile.apply(this, arguments);
      }

      return uploadFile;
    }()
  }, {
    key: "tapYesButton",
    value: function () {
      var _tapYesButton = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.tapButton({
                text: "Yes",
                index: 0
              });

            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));

      function tapYesButton() {
        return _tapYesButton.apply(this, arguments);
      }

      return tapYesButton;
    }()
  }, {
    key: "tapNoButton",
    value: function () {
      var _tapNoButton = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.tapButton({
                text: "No",
                index: 0
              });

            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));

      function tapNoButton() {
        return _tapNoButton.apply(this, arguments);
      }

      return tapNoButton;
    }()
  }, {
    key: "tapContinueButton",
    value: function () {
      var _tapContinueButton = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.tapButton({
                text: "Continue",
                index: 0
              });

            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));

      function tapContinueButton() {
        return _tapContinueButton.apply(this, arguments);
      }

      return tapContinueButton;
    }()
  }, {
    key: "tapButton",
    value: function () {
      var _tapButton = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(options) {
        var text, textOnFailure, index, buttons, filteredButtonsWithText, validButtonsWithText, performedTap, _iterator2, _step2, _button, _isAttached, _screenshotLocation3, _isButtonDisabled, _screenshotLocation4, filteredButtonsWithTextOnFailure, validButtonsWithTextOnFailure, _iterator3, _step3, button, isAttached, screenshotLocation, isButtonDisabled, _screenshotLocation, _screenshotLocation2;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              text = options.text, textOnFailure = options.textOnFailure, index = options.index;
              _context7.next = 3;
              return this._page.$$("button");

            case 3:
              buttons = _context7.sent;
              _context7.next = 6;
              return Promise.all(buttons.map( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(button) {
                  var buttonText;
                  return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        _context5.next = 2;
                        return button.evaluate(function (e) {
                          return e.innerText;
                        });

                      case 2:
                        _context5.t0 = _context5.sent;

                        if (_context5.t0) {
                          _context5.next = 5;
                          break;
                        }

                        _context5.t0 = "";

                      case 5:
                        buttonText = _context5.t0;
                        return _context5.abrupt("return", buttonText.toLowerCase().includes(text.toLowerCase()) ? button : null);

                      case 7:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee5);
                }));

                return function (_x4) {
                  return _ref2.apply(this, arguments);
                };
              }()));

            case 6:
              filteredButtonsWithText = _context7.sent;
              validButtonsWithText = filteredButtonsWithText.filter(function (button) {
                return button !== null;
              });

              if (index !== undefined && index !== null && index >= 0 && validButtonsWithText.length > index) {
                validButtonsWithText = [validButtonsWithText[index]];
              }

              performedTap = false;
              _iterator2 = _createForOfIteratorHelper(validButtonsWithText);
              _context7.prev = 11;

              _iterator2.s();

            case 13:
              if ((_step2 = _iterator2.n()).done) {
                _context7.next = 42;
                break;
              }

              _button = _step2.value;
              _context7.next = 17;
              return this.isElementAttached(_button);

            case 17:
              _isAttached = _context7.sent;

              if (_isAttached) {
                _context7.next = 23;
                break;
              }

              _context7.next = 21;
              return this.takeScreenshot();

            case 21:
              _screenshotLocation3 = _context7.sent;
              throw new Error("Screenshot here: ".concat(_screenshotLocation3, "\ntapButton failed: Button with text \"").concat(text, "\" on index ").concat(index, " is detached from the DOM."));

            case 23:
              _context7.next = 25;
              return this.waitForElementEnabled(_button, 300);

            case 25:
              _context7.next = 27;
              return _button.evaluate(function (e) {
                return e.hasAttribute("disabled");
              });

            case 27:
              _isButtonDisabled = _context7.sent;
              _context7.next = 30;
              return (0, exports.scrollIntoView)(this._page, _button);

            case 30:
              if (!_isButtonDisabled) {
                _context7.next = 35;
                break;
              }

              _context7.next = 33;
              return this.takeScreenshot();

            case 33:
              _screenshotLocation4 = _context7.sent;
              throw new Error("Screenshot here: ".concat(_screenshotLocation4, "\ntapButton failed: Button with text \"").concat(text, "\" on index ").concat(index, " is disabled and cannot be tapped!"));

            case 35:
              _context7.next = 37;
              return _button.tap();

            case 37:
              _context7.next = 39;
              return this._page.waitForTimeout(100);

            case 39:
              performedTap = true;

            case 40:
              _context7.next = 13;
              break;

            case 42:
              _context7.next = 47;
              break;

            case 44:
              _context7.prev = 44;
              _context7.t0 = _context7["catch"](11);

              _iterator2.e(_context7.t0);

            case 47:
              _context7.prev = 47;

              _iterator2.f();

              return _context7.finish(47);

            case 50:
              if (!(!performedTap && textOnFailure !== null && textOnFailure !== undefined)) {
                _context7.next = 96;
                break;
              }

              _context7.next = 53;
              return Promise.all(buttons.map( /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(button) {
                  var buttonText;
                  return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) switch (_context6.prev = _context6.next) {
                      case 0:
                        _context6.next = 2;
                        return button.evaluate(function (e) {
                          return e.innerText;
                        });

                      case 2:
                        _context6.t0 = _context6.sent;

                        if (_context6.t0) {
                          _context6.next = 5;
                          break;
                        }

                        _context6.t0 = "";

                      case 5:
                        buttonText = _context6.t0;
                        return _context6.abrupt("return", buttonText.toLowerCase().includes((textOnFailure || "").toLowerCase()) ? button : null);

                      case 7:
                      case "end":
                        return _context6.stop();
                    }
                  }, _callee6);
                }));

                return function (_x5) {
                  return _ref3.apply(this, arguments);
                };
              }()));

            case 53:
              filteredButtonsWithTextOnFailure = _context7.sent;
              validButtonsWithTextOnFailure = filteredButtonsWithTextOnFailure.filter(function (button) {
                return button !== null;
              });

              if (index !== undefined && index !== null && index >= 0 && validButtonsWithTextOnFailure.length > index) {
                validButtonsWithTextOnFailure = [validButtonsWithTextOnFailure[index]];
              }

              _iterator3 = _createForOfIteratorHelper(validButtonsWithTextOnFailure);
              _context7.prev = 57;

              _iterator3.s();

            case 59:
              if ((_step3 = _iterator3.n()).done) {
                _context7.next = 88;
                break;
              }

              button = _step3.value;
              _context7.next = 63;
              return this.isElementAttached(button);

            case 63:
              isAttached = _context7.sent;

              if (isAttached) {
                _context7.next = 69;
                break;
              }

              _context7.next = 67;
              return this.takeScreenshot();

            case 67:
              screenshotLocation = _context7.sent;
              throw new Error("Screenshot here: ".concat(screenshotLocation, "\ntapButton failed: Button with text \"").concat(textOnFailure, "\" on index ").concat(index, " is detached from the DOM."));

            case 69:
              _context7.next = 71;
              return this.waitForElementEnabled(button, 300);

            case 71:
              _context7.next = 73;
              return button.evaluate(function (e) {
                return e.hasAttribute("disabled");
              });

            case 73:
              isButtonDisabled = _context7.sent;

              if (!isButtonDisabled) {
                _context7.next = 79;
                break;
              }

              _context7.next = 77;
              return this.takeScreenshot();

            case 77:
              _screenshotLocation = _context7.sent;
              throw new Error("Screenshot here: ".concat(_screenshotLocation, "\ntapButton failed: Button with text \"").concat(textOnFailure, "\" on index ").concat(index, " is disabled and cannot be tapped!"));

            case 79:
              _context7.next = 81;
              return (0, exports.scrollIntoView)(this._page, button);

            case 81:
              _context7.next = 83;
              return button.tap();

            case 83:
              _context7.next = 85;
              return this._page.waitForTimeout(100);

            case 85:
              performedTap = true;

            case 86:
              _context7.next = 59;
              break;

            case 88:
              _context7.next = 93;
              break;

            case 90:
              _context7.prev = 90;
              _context7.t1 = _context7["catch"](57);

              _iterator3.e(_context7.t1);

            case 93:
              _context7.prev = 93;

              _iterator3.f();

              return _context7.finish(93);

            case 96:
              if (performedTap) {
                _context7.next = 101;
                break;
              }

              _context7.next = 99;
              return this.takeScreenshot();

            case 99:
              _screenshotLocation2 = _context7.sent;
              throw new Error("Screenshot here: ".concat(_screenshotLocation2, "\ntapButton found nothing to tap with the text \"").concat(text, "\" or with the text \"").concat(textOnFailure, "\" on index ").concat(index, "!"));

            case 101:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[11, 44, 47, 50], [57, 90, 93, 96]]);
      }));

      function tapButton(_x3) {
        return _tapButton.apply(this, arguments);
      }

      return tapButton;
    }()
  }, {
    key: "isElementAttached",
    value: function () {
      var _isElementAttached = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(elementHandle) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              return _context8.abrupt("return", elementHandle.evaluate(function (e) {
                return document.body.contains(e);
              }));

            case 1:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }));

      function isElementAttached(_x6) {
        return _isElementAttached.apply(this, arguments);
      }

      return isElementAttached;
    }()
  }, {
    key: "waitForElementEnabled",
    value: function () {
      var _waitForElementEnabled = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(element, timeoutMs) {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return this._page.waitForTimeout(100);

            case 2:
              _context10.next = 4;
              return Promise.race([new Promise(function (resolve) {
                var interval = setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
                  var isButtonEnabled;
                  return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) switch (_context9.prev = _context9.next) {
                      case 0:
                        _context9.next = 2;
                        return element.evaluate(function (e) {
                          return !e.hasAttribute("disabled");
                        });

                      case 2:
                        isButtonEnabled = _context9.sent;

                        if (isButtonEnabled) {
                          clearInterval(interval);
                          resolve();
                        }

                      case 4:
                      case "end":
                        return _context9.stop();
                    }
                  }, _callee9);
                })), 100);
              }), new Promise(function (resolve) {
                return setTimeout(resolve, timeoutMs);
              })]);

            case 4:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));

      function waitForElementEnabled(_x7, _x8) {
        return _waitForElementEnabled.apply(this, arguments);
      }

      return waitForElementEnabled;
    }()
  }, {
    key: "tapLink",
    value: function () {
      var _tapLink = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(options) {
        var text, index, links, filteredLinksWithText, validLinksWithText, screenshotLocation, performedTap, _iterator4, _step4, link, isAttached, _screenshotLocation6, isLinkDisabled, _screenshotLocation7, _screenshotLocation5;

        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              text = options.text, index = options.index;
              _context12.next = 3;
              return this._page.$$("a");

            case 3:
              links = _context12.sent;
              _context12.next = 6;
              return Promise.all(links.map( /*#__PURE__*/function () {
                var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(link) {
                  var buttonText;
                  return _regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) switch (_context11.prev = _context11.next) {
                      case 0:
                        _context11.next = 2;
                        return link.evaluate(function (e) {
                          return e.innerText;
                        });

                      case 2:
                        _context11.t0 = _context11.sent;

                        if (_context11.t0) {
                          _context11.next = 5;
                          break;
                        }

                        _context11.t0 = "";

                      case 5:
                        buttonText = _context11.t0;
                        return _context11.abrupt("return", buttonText.toLowerCase().includes(text.toLowerCase()) ? link : null);

                      case 7:
                      case "end":
                        return _context11.stop();
                    }
                  }, _callee11);
                }));

                return function (_x10) {
                  return _ref5.apply(this, arguments);
                };
              }()));

            case 6:
              filteredLinksWithText = _context12.sent;
              validLinksWithText = filteredLinksWithText.filter(function (link) {
                return link !== null;
              });

              if (index !== undefined && index !== null && index >= 0 && validLinksWithText.length > index) {
                validLinksWithText = [validLinksWithText[index]];
              }

              if (!(validLinksWithText.length === 0)) {
                _context12.next = 14;
                break;
              }

              _context12.next = 12;
              return this.takeScreenshot();

            case 12:
              screenshotLocation = _context12.sent;
              throw new Error("Screenshot here: ".concat(screenshotLocation, "\n.tapLink failed: Link with text \"").concat(text, "\" on index ").concat(index, " was not found!"));

            case 14:
              performedTap = false;
              _iterator4 = _createForOfIteratorHelper(validLinksWithText);
              _context12.prev = 16;

              _iterator4.s();

            case 18:
              if ((_step4 = _iterator4.n()).done) {
                _context12.next = 49;
                break;
              }

              link = _step4.value;
              _context12.next = 22;
              return this.isElementAttached(link);

            case 22:
              isAttached = _context12.sent;

              if (isAttached) {
                _context12.next = 28;
                break;
              }

              _context12.next = 26;
              return this.takeScreenshot();

            case 26:
              _screenshotLocation6 = _context12.sent;
              throw new Error("Screenshot here: ".concat(_screenshotLocation6, "\n.tapLink failed: Link with text \"").concat(text, "\" on index ").concat(index, " is detached from the DOM."));

            case 28:
              _context12.next = 30;
              return this.waitForElementEnabled(link, 300);

            case 30:
              _context12.next = 32;
              return link.evaluate(function (e) {
                return e.hasAttribute("disabled");
              });

            case 32:
              isLinkDisabled = _context12.sent;

              if (!isLinkDisabled) {
                _context12.next = 38;
                break;
              }

              _context12.next = 36;
              return this.takeScreenshot();

            case 36:
              _screenshotLocation7 = _context12.sent;
              throw new Error("Screenshot here: ".concat(_screenshotLocation7, "\n.tapLink failed: Link with text \"").concat(text, "\" on index ").concat(index, " is disabled and cannot be tapped!"));

            case 38:
              _context12.next = 40;
              return (0, exports.scrollIntoView)(this._page, link);

            case 40:
              _context12.next = 42;
              return this._page.evaluate(function (link) {
                link.addEventListener("click", function (event) {
                  event.preventDefault();
                });
              }, link);

            case 42:
              _context12.next = 44;
              return link.tap();

            case 44:
              _context12.next = 46;
              return this._page.waitForTimeout(100);

            case 46:
              performedTap = true;

            case 47:
              _context12.next = 18;
              break;

            case 49:
              _context12.next = 54;
              break;

            case 51:
              _context12.prev = 51;
              _context12.t0 = _context12["catch"](16);

              _iterator4.e(_context12.t0);

            case 54:
              _context12.prev = 54;

              _iterator4.f();

              return _context12.finish(54);

            case 57:
              if (performedTap) {
                _context12.next = 62;
                break;
              }

              _context12.next = 60;
              return this.takeScreenshot();

            case 60:
              _screenshotLocation5 = _context12.sent;
              throw new Error("Screenshot here: ".concat(_screenshotLocation5, "\n.tapLink() found nothing to tap with the text ").concat(text, " on index ").concat(index, "! Screenshot Data URL above."));

            case 62:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this, [[16, 51, 54, 57]]);
      }));

      function tapLink(_x9) {
        return _tapLink.apply(this, arguments);
      }

      return tapLink;
    }()
  }, {
    key: "tapInput",
    value: function () {
      var _tapInput = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(options) {
        var label, option, index, cssSelector, elms, performedTap, _iterator5, _step5, elm, testOption, screenshotLocation;

        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              label = options.label, option = options.option, index = options.index;
              cssSelector = ".content-node__input";

              if (label !== undefined) {
                cssSelector += " [data-test-label*=\"".concat(label, "\"]");
              }

              if (option !== undefined && label !== undefined) {
                cssSelector += "[data-test-option*=\"".concat(option, "\"]");
              } else if (option !== undefined) {
                cssSelector += " [data-test-option*=\"".concat(option, "\"]");
              }

              _context13.next = 6;
              return this.getElementsAtIndex(cssSelector, index);

            case 6:
              elms = _context13.sent;
              performedTap = false;
              _iterator5 = _createForOfIteratorHelper(elms);
              _context13.prev = 9;

              _iterator5.s();

            case 11:
              if ((_step5 = _iterator5.n()).done) {
                _context13.next = 28;
                break;
              }

              elm = _step5.value;
              _context13.next = 15;
              return elm.evaluate(function (n) {
                return n.getAttribute("data-test-option");
              });

            case 15:
              _context13.t0 = _context13.sent;

              if (_context13.t0) {
                _context13.next = 18;
                break;
              }

              _context13.t0 = "";

            case 18:
              testOption = _context13.t0;

              if (!(option && testOption.indexOf(option) === -1)) {
                _context13.next = 21;
                break;
              }

              return _context13.abrupt("continue", 26);

            case 21:
              _context13.next = 23;
              return elm.tap();

            case 23:
              _context13.next = 25;
              return this._page.waitForTimeout(100);

            case 25:
              performedTap = true;

            case 26:
              _context13.next = 11;
              break;

            case 28:
              _context13.next = 33;
              break;

            case 30:
              _context13.prev = 30;
              _context13.t1 = _context13["catch"](9);

              _iterator5.e(_context13.t1);

            case 33:
              _context13.prev = 33;

              _iterator5.f();

              return _context13.finish(33);

            case 36:
              if (performedTap) {
                _context13.next = 41;
                break;
              }

              _context13.next = 39;
              return this.takeScreenshot();

            case 39:
              screenshotLocation = _context13.sent;
              throw new Error("Screenshot here: ".concat(screenshotLocation, "\n.tapInput() found nothing to tap").concat(label ? " with the label ".concat(label) : "").concat(index !== undefined ? " on index ".concat(index) : "").concat(option ? " with the option ".concat(option) : "", "! CSS Selector: \"").concat(cssSelector, "\". Screenshot Data URL above."));

            case 41:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this, [[9, 30, 33, 36]]);
      }));

      function tapInput(_x11) {
        return _tapInput.apply(this, arguments);
      }

      return tapInput;
    }()
  }, {
    key: "tapSelectInput",
    value: function () {
      var _tapSelectInput = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(options) {
        var label, value, text, index, cssSelector, elms, performedTap, _iterator6, _step6, elm, selectedOptionValue, screenshotLocation;

        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              label = options.label, value = options.value, text = options.text, index = options.index;
              cssSelector = ".content-node__input select[data-test-label*=\"".concat(label, "\"]");
              _context14.next = 4;
              return this.getElementsAtIndex(cssSelector, index);

            case 4:
              elms = _context14.sent;
              performedTap = false;
              _iterator6 = _createForOfIteratorHelper(elms);
              _context14.prev = 7;

              _iterator6.s();

            case 9:
              if ((_step6 = _iterator6.n()).done) {
                _context14.next = 25;
                break;
              }

              elm = _step6.value;
              selectedOptionValue = value;

              if (!(!selectedOptionValue && text)) {
                _context14.next = 16;
                break;
              }

              _context14.next = 15;
              return elm.evaluate(function (el, text) {
                if (el instanceof HTMLSelectElement) {
                  var selectedIndex = Array.from(el.options).findIndex(function (option) {
                    return option.textContent === text;
                  });
                  return selectedIndex !== -1 ? el.options[selectedIndex].value : undefined;
                }

                return undefined;
              }, text);

            case 15:
              selectedOptionValue = _context14.sent;

            case 16:
              if (!(selectedOptionValue == null)) {
                _context14.next = 18;
                break;
              }

              return _context14.abrupt("continue", 23);

            case 18:
              _context14.next = 20;
              return elm.select(selectedOptionValue);

            case 20:
              _context14.next = 22;
              return this._page.waitForTimeout(100);

            case 22:
              performedTap = true;

            case 23:
              _context14.next = 9;
              break;

            case 25:
              _context14.next = 30;
              break;

            case 27:
              _context14.prev = 27;
              _context14.t0 = _context14["catch"](7);

              _iterator6.e(_context14.t0);

            case 30:
              _context14.prev = 30;

              _iterator6.f();

              return _context14.finish(30);

            case 33:
              if (performedTap) {
                _context14.next = 38;
                break;
              }

              _context14.next = 36;
              return this.takeScreenshot();

            case 36:
              screenshotLocation = _context14.sent;
              throw new Error("Screenshot here: ".concat(screenshotLocation, "\n.tapSelectInput() found nothing to tap with the label ").concat(label, " on index ").concat(index, "! Screenshot Data URL above."));

            case 38:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this, [[7, 27, 30, 33]]);
      }));

      function tapSelectInput(_x12) {
        return _tapSelectInput.apply(this, arguments);
      }

      return tapSelectInput;
    }()
  }, {
    key: "tapSelectDateInput",
    value: function () {
      var _tapSelectDateInput = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(options) {
        var label, date, index, cssSelector, elms, performedTap, _iterator7, _step7, elm, grandParentElement, firstChild, secondChild, childElms, testLabel, _yield$secondChild$$$, _yield$secondChild$$$2, monthElm, dayElm, yearElm, screenshotLocation;

        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              label = options.label, date = options.date, index = options.index;
              cssSelector = ".content-node__input.date [data-test-label*=\"".concat(label, "\"]");
              _context15.next = 4;
              return this.getElementsAtIndex(cssSelector, index);

            case 4:
              elms = _context15.sent;
              performedTap = false;
              _iterator7 = _createForOfIteratorHelper(elms);
              _context15.prev = 7;

              _iterator7.s();

            case 9:
              if ((_step7 = _iterator7.n()).done) {
                _context15.next = 57;
                break;
              }

              elm = _step7.value;
              _context15.next = 13;
              return elm.$x("./../..");

            case 13:
              grandParentElement = _context15.sent[0];

              if (grandParentElement) {
                _context15.next = 16;
                break;
              }

              return _context15.abrupt("continue", 55);

            case 16:
              _context15.next = 18;
              return grandParentElement.$(":first-child");

            case 18:
              firstChild = _context15.sent;
              _context15.next = 21;
              return grandParentElement.$(":nth-child(2)");

            case 21:
              secondChild = _context15.sent;

              if (!(!firstChild || !secondChild)) {
                _context15.next = 24;
                break;
              }

              return _context15.abrupt("continue", 55);

            case 24:
              _context15.next = 26;
              return firstChild.$$("[class]");

            case 26:
              childElms = _context15.sent;

              if (childElms) {
                _context15.next = 29;
                break;
              }

              return _context15.abrupt("continue", 55);

            case 29:
              _context15.next = 31;
              return this._page.evaluate(function (el) {
                return el.innerHTML || "";
              }, childElms[0]);

            case 31:
              testLabel = _context15.sent;

              if (!(testLabel.indexOf(label) !== -1)) {
                _context15.next = 55;
                break;
              }

              _context15.next = 35;
              return secondChild.$$("select");

            case 35:
              _yield$secondChild$$$ = _context15.sent;
              _yield$secondChild$$$2 = _slicedToArray(_yield$secondChild$$$, 3);
              monthElm = _yield$secondChild$$$2[0];
              dayElm = _yield$secondChild$$$2[1];
              yearElm = _yield$secondChild$$$2[2];

              if (!(!monthElm || !dayElm || !yearElm)) {
                _context15.next = 42;
                break;
              }

              return _context15.abrupt("continue", 55);

            case 42:
              _context15.next = 44;
              return monthElm.select(String(date.getMonth()));

            case 44:
              _context15.next = 46;
              return this._page.waitForTimeout(100);

            case 46:
              _context15.next = 48;
              return dayElm.select(String(date.getDate()));

            case 48:
              _context15.next = 50;
              return this._page.waitForTimeout(100);

            case 50:
              _context15.next = 52;
              return yearElm.select(String(date.getFullYear()));

            case 52:
              _context15.next = 54;
              return this._page.waitForTimeout(100);

            case 54:
              performedTap = true;

            case 55:
              _context15.next = 9;
              break;

            case 57:
              _context15.next = 62;
              break;

            case 59:
              _context15.prev = 59;
              _context15.t0 = _context15["catch"](7);

              _iterator7.e(_context15.t0);

            case 62:
              _context15.prev = 62;

              _iterator7.f();

              return _context15.finish(62);

            case 65:
              if (performedTap) {
                _context15.next = 70;
                break;
              }

              _context15.next = 68;
              return this.takeScreenshot();

            case 68:
              screenshotLocation = _context15.sent;
              throw new Error("Screenshot here: ".concat(screenshotLocation, "\n.tapSelectDateInput() found nothing to tap with the label ").concat(label, " on index ").concat(index, "! Screenshot Data URL above."));

            case 70:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this, [[7, 59, 62, 65]]);
      }));

      function tapSelectDateInput(_x13) {
        return _tapSelectDateInput.apply(this, arguments);
      }

      return tapSelectDateInput;
    }()
  }, {
    key: "tapSelectAgeInput",
    value: function () {
      var _tapSelectAgeInput = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(options) {
        var label, years, months, index, cssSelector, elms, performedTap, _iterator8, _step8, elm, firstChild, childElms, testLabel, _yield$childElms$1$$$, _yield$childElms$1$$$2, yearsElm, monthsElm, screenshotLocation;

        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              label = options.label, years = options.years, months = options.months, index = options.index;
              cssSelector = ".content-node__input.age [data-test-label*=\"".concat(label, "\"]");
              _context16.next = 4;
              return this.getElementsAtIndex(cssSelector, index);

            case 4:
              elms = _context16.sent;
              performedTap = false;
              _iterator8 = _createForOfIteratorHelper(elms);
              _context16.prev = 7;

              _iterator8.s();

            case 9:
              if ((_step8 = _iterator8.n()).done) {
                _context16.next = 44;
                break;
              }

              elm = _step8.value;
              _context16.next = 13;
              return elm.$(":first-child");

            case 13:
              firstChild = _context16.sent;

              if (firstChild) {
                _context16.next = 16;
                break;
              }

              return _context16.abrupt("continue", 42);

            case 16:
              _context16.next = 18;
              return firstChild.$$("[class]");

            case 18:
              childElms = _context16.sent;

              if (!(!childElms || childElms.length < 2)) {
                _context16.next = 21;
                break;
              }

              return _context16.abrupt("continue", 42);

            case 21:
              _context16.next = 23;
              return this._page.evaluate(function (el) {
                return el.getAttribute("data-test-label") || "";
              }, childElms[0]);

            case 23:
              testLabel = _context16.sent;

              if (!(testLabel.indexOf(label) !== -1)) {
                _context16.next = 42;
                break;
              }

              _context16.next = 27;
              return childElms[1].$$("select");

            case 27:
              _yield$childElms$1$$$ = _context16.sent;
              _yield$childElms$1$$$2 = _slicedToArray(_yield$childElms$1$$$, 2);
              yearsElm = _yield$childElms$1$$$2[0];
              monthsElm = _yield$childElms$1$$$2[1];

              if (!(!yearsElm || !monthsElm)) {
                _context16.next = 33;
                break;
              }

              return _context16.abrupt("continue", 42);

            case 33:
              _context16.next = 35;
              return yearsElm.select("".concat(years, " Years"));

            case 35:
              _context16.next = 37;
              return this._page.waitForTimeout(100);

            case 37:
              _context16.next = 39;
              return monthsElm.select("".concat(months, " Months"));

            case 39:
              _context16.next = 41;
              return this._page.waitForTimeout(100);

            case 41:
              performedTap = true;

            case 42:
              _context16.next = 9;
              break;

            case 44:
              _context16.next = 49;
              break;

            case 46:
              _context16.prev = 46;
              _context16.t0 = _context16["catch"](7);

              _iterator8.e(_context16.t0);

            case 49:
              _context16.prev = 49;

              _iterator8.f();

              return _context16.finish(49);

            case 52:
              if (performedTap) {
                _context16.next = 57;
                break;
              }

              _context16.next = 55;
              return this.takeScreenshot();

            case 55:
              screenshotLocation = _context16.sent;
              throw new Error("Screenshot here: ".concat(screenshotLocation, "\n.tapSelectAgeInput() found nothing to tap with the label ").concat(label, " on index ").concat(index, "! Screenshot Data URL above."));

            case 57:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this, [[7, 46, 49, 52]]);
      }));

      function tapSelectAgeInput(_x14) {
        return _tapSelectAgeInput.apply(this, arguments);
      }

      return tapSelectAgeInput;
    }()
  }, {
    key: "typeInput",
    value: function () {
      var _typeInput = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(options) {
        var placeholder, label, text, index, cssSelectorByLabel, cssSelectorByPlaceholder, elmsByLabel, performedType, _iterator9, _step9, _elm, elmsByPlaceholder, _iterator10, _step10, elm, screenshotLocation;

        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              placeholder = options.placeholder, label = options.label, text = options.text, index = options.index;
              cssSelectorByLabel = ".content-node__input [data-test-label*=\"".concat(label, "\"]");
              cssSelectorByPlaceholder = ".content-node__input [placeholder*=\"".concat(placeholder, "\"]");
              _context17.next = 5;
              return this.getElementsAtIndex(cssSelectorByLabel, index);

            case 5:
              elmsByLabel = _context17.sent;
              performedType = false;
              _iterator9 = _createForOfIteratorHelper(elmsByLabel);
              _context17.prev = 8;

              _iterator9.s();

            case 10:
              if ((_step9 = _iterator9.n()).done) {
                _context17.next = 21;
                break;
              }

              _elm = _step9.value;
              _context17.next = 14;
              return _elm.evaluate(function (el) {
                if (el instanceof HTMLInputElement) {
                  el.value = "";
                }
              });

            case 14:
              _context17.next = 16;
              return _elm.type(text);

            case 16:
              _context17.next = 18;
              return this._page.waitForTimeout(100);

            case 18:
              performedType = true;

            case 19:
              _context17.next = 10;
              break;

            case 21:
              _context17.next = 26;
              break;

            case 23:
              _context17.prev = 23;
              _context17.t0 = _context17["catch"](8);

              _iterator9.e(_context17.t0);

            case 26:
              _context17.prev = 26;

              _iterator9.f();

              return _context17.finish(26);

            case 29:
              if (performedType) {
                _context17.next = 60;
                break;
              }

              _context17.next = 32;
              return this.getElementsAtIndex(cssSelectorByPlaceholder, index);

            case 32:
              elmsByPlaceholder = _context17.sent;
              _iterator10 = _createForOfIteratorHelper(elmsByPlaceholder);
              _context17.prev = 34;

              _iterator10.s();

            case 36:
              if ((_step10 = _iterator10.n()).done) {
                _context17.next = 47;
                break;
              }

              elm = _step10.value;
              _context17.next = 40;
              return elm.evaluate(function (el) {
                if (el instanceof HTMLInputElement) {
                  el.value = "";
                }
              });

            case 40:
              _context17.next = 42;
              return elm.type(text);

            case 42:
              _context17.next = 44;
              return this._page.waitForTimeout(100);

            case 44:
              performedType = true;

            case 45:
              _context17.next = 36;
              break;

            case 47:
              _context17.next = 52;
              break;

            case 49:
              _context17.prev = 49;
              _context17.t1 = _context17["catch"](34);

              _iterator10.e(_context17.t1);

            case 52:
              _context17.prev = 52;

              _iterator10.f();

              return _context17.finish(52);

            case 55:
              if (performedType) {
                _context17.next = 60;
                break;
              }

              _context17.next = 58;
              return this.takeScreenshot();

            case 58:
              screenshotLocation = _context17.sent;
              throw new Error("Screenshot here: ".concat(screenshotLocation, "\n.typeInput() found nothing to type into the label \"").concat(label, "\" or placeholder \"").concat(placeholder, "\" on index ").concat(index, "! Screenshot Data URL above."));

            case 60:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this, [[8, 23, 26, 29], [34, 49, 52, 55]]);
      }));

      function typeInput(_x15) {
        return _typeInput.apply(this, arguments);
      }

      return typeInput;
    }()
  }, {
    key: "fillArrayInput",
    value: function () {
      var _fillArrayInput = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(options) {
        var label, text, index, inputSelector, labelSelector, labelElements, inputElements, performedFill, i, labelElement, inputElement, labelText, screenshotLocation;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              label = options.label, text = options.text, index = options.index;
              inputSelector = ".json-panel__inputs.row > label.text > input[type=\"text\"]";
              labelSelector = ".json-panel__inputs.row > label.text > small.content-node__input__label";
              _context18.next = 5;
              return this.getElementsAtIndex(labelSelector, index);

            case 5:
              labelElements = _context18.sent;
              _context18.next = 8;
              return this.getElementsAtIndex(inputSelector, index);

            case 8:
              inputElements = _context18.sent;
              performedFill = false;
              i = 0;

            case 11:
              if (!(i < labelElements.length)) {
                _context18.next = 29;
                break;
              }

              labelElement = labelElements[i];
              inputElement = inputElements[i];

              if (!(labelElement && inputElement)) {
                _context18.next = 26;
                break;
              }

              _context18.next = 17;
              return labelElement.evaluate(function (el) {
                var _a;

                return (_a = el.textContent) === null || _a === void 0 ? void 0 : _a.trim();
              });

            case 17:
              labelText = _context18.sent;

              if (!(labelText && labelText.includes(label))) {
                _context18.next = 26;
                break;
              }

              _context18.next = 21;
              return inputElement.evaluate(function (el) {
                if (el instanceof HTMLInputElement) {
                  el.value = "";
                }
              });

            case 21:
              _context18.next = 23;
              return inputElement.type(text);

            case 23:
              _context18.next = 25;
              return this._page.waitForTimeout(100);

            case 25:
              performedFill = true;

            case 26:
              i++;
              _context18.next = 11;
              break;

            case 29:
              if (performedFill) {
                _context18.next = 34;
                break;
              }

              _context18.next = 32;
              return this.takeScreenshot();

            case 32:
              screenshotLocation = _context18.sent;
              throw new Error("Screenshot here: ".concat(screenshotLocation, "\n.fillInput() found no input field with the label \"").concat(label, "\" to fill in on index ").concat(index, "! Screenshot Data URL above."));

            case 34:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this);
      }));

      function fillArrayInput(_x16) {
        return _fillArrayInput.apply(this, arguments);
      }

      return fillArrayInput;
    }()
  }, {
    key: "isElementEnabled",
    value: function () {
      var _isElementEnabled = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(element) {
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              return _context19.abrupt("return", element.evaluate(function (e) {
                return !e.hasAttribute("disabled");
              }));

            case 1:
            case "end":
              return _context19.stop();
          }
        }, _callee19);
      }));

      function isElementEnabled(_x17) {
        return _isElementEnabled.apply(this, arguments);
      }

      return isElementEnabled;
    }()
  }, {
    key: "waitForTimeout",
    value: function () {
      var _waitForTimeout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(options) {
        var timeoutMs, checkButtonEnabledText, startTime, buttons, filteredButtonsWithText, validButtonsWithText, _iterator11, _step11, targetButton, isAttached, isEnabled;

        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              timeoutMs = options.timeoutMs, checkButtonEnabledText = options.checkButtonEnabledText;

              if (!checkButtonEnabledText) {
                _context21.next = 42;
                break;
              }

              startTime = Date.now();

            case 3:
              if (!(Date.now() - startTime < timeoutMs)) {
                _context21.next = 40;
                break;
              }

              _context21.next = 6;
              return this._page.waitForTimeout(100);

            case 6:
              _context21.next = 8;
              return this._page.$$("button");

            case 8:
              buttons = _context21.sent;
              _context21.next = 11;
              return Promise.all(buttons.map( /*#__PURE__*/function () {
                var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(button) {
                  var buttonText;
                  return _regeneratorRuntime.wrap(function _callee20$(_context20) {
                    while (1) switch (_context20.prev = _context20.next) {
                      case 0:
                        _context20.next = 2;
                        return button.evaluate(function (e) {
                          return e.innerText;
                        });

                      case 2:
                        _context20.t0 = _context20.sent;

                        if (_context20.t0) {
                          _context20.next = 5;
                          break;
                        }

                        _context20.t0 = "";

                      case 5:
                        buttonText = _context20.t0;
                        return _context20.abrupt("return", buttonText.toLowerCase().includes(checkButtonEnabledText.toLowerCase()) ? button : null);

                      case 7:
                      case "end":
                        return _context20.stop();
                    }
                  }, _callee20);
                }));

                return function (_x19) {
                  return _ref6.apply(this, arguments);
                };
              }()));

            case 11:
              filteredButtonsWithText = _context21.sent;
              validButtonsWithText = filteredButtonsWithText.filter(function (button) {
                return button !== null;
              });

              if (!(validButtonsWithText.length > 0)) {
                _context21.next = 38;
                break;
              }

              _iterator11 = _createForOfIteratorHelper(validButtonsWithText);
              _context21.prev = 15;

              _iterator11.s();

            case 17:
              if ((_step11 = _iterator11.n()).done) {
                _context21.next = 30;
                break;
              }

              targetButton = _step11.value;
              _context21.next = 21;
              return this.isElementAttached(targetButton);

            case 21:
              isAttached = _context21.sent;

              if (!isAttached) {
                _context21.next = 28;
                break;
              }

              _context21.next = 25;
              return this.isElementEnabled(targetButton);

            case 25:
              isEnabled = _context21.sent;

              if (!isEnabled) {
                _context21.next = 28;
                break;
              }

              return _context21.abrupt("return");

            case 28:
              _context21.next = 17;
              break;

            case 30:
              _context21.next = 35;
              break;

            case 32:
              _context21.prev = 32;
              _context21.t0 = _context21["catch"](15);

              _iterator11.e(_context21.t0);

            case 35:
              _context21.prev = 35;

              _iterator11.f();

              return _context21.finish(35);

            case 38:
              _context21.next = 3;
              break;

            case 40:
              _context21.next = 44;
              break;

            case 42:
              _context21.next = 44;
              return this._page.waitForTimeout(timeoutMs);

            case 44:
            case "end":
              return _context21.stop();
          }
        }, _callee21, this, [[15, 32, 35, 38]]);
      }));

      function waitForTimeout(_x18) {
        return _waitForTimeout.apply(this, arguments);
      }

      return waitForTimeout;
    }()
  }, {
    key: "takeScreenshot",
    value: function () {
      var _takeScreenshot = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22() {
        var screenshotBuffer, dataUrl;
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              _context22.next = 2;
              return this._page.screenshot();

            case 2:
              screenshotBuffer = _context22.sent;
              dataUrl = "data:image/png;base64,".concat(screenshotBuffer.toString("base64"));
              return _context22.abrupt("return", dataUrl);

            case 5:
            case "end":
              return _context22.stop();
          }
        }, _callee22, this);
      }));

      function takeScreenshot() {
        return _takeScreenshot.apply(this, arguments);
      }

      return takeScreenshot;
    }()
  }, {
    key: "getElementsAtIndex",
    value: function () {
      var _getElementsAtIndex = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(selector, index) {
        var elements;
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              _context23.next = 2;
              return this._page.$$(selector);

            case 2:
              elements = _context23.sent;
              return _context23.abrupt("return", index !== undefined && index !== null ? elements[index] ? [elements[index]] : [] : elements);

            case 4:
            case "end":
              return _context23.stop();
          }
        }, _callee23, this);
      }));

      function getElementsAtIndex(_x20, _x21) {
        return _getElementsAtIndex.apply(this, arguments);
      }

      return getElementsAtIndex;
    }()
  }]);

  return PuppeteerTestUtils;
}();

exports.PuppeteerTestUtils = PuppeteerTestUtils;

var scrollIntoView = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(page, selectorOrElm) {
    return _regeneratorRuntime.wrap(function _callee24$(_context24) {
      while (1) switch (_context24.prev = _context24.next) {
        case 0:
          if (!(typeof selectorOrElm === "string")) {
            _context24.next = 5;
            break;
          }

          _context24.next = 3;
          return page.$eval(selectorOrElm, function (e) {
            return e.scrollIntoView({
              behavior: "auto",
              block: "center",
              inline: "center"
            });
          });

        case 3:
          _context24.next = 7;
          break;

        case 5:
          _context24.next = 7;
          return selectorOrElm.evaluate(function (e) {
            return e.scrollIntoView({
              behavior: "auto",
              block: "center",
              inline: "center"
            });
          });

        case 7:
        case "end":
          return _context24.stop();
      }
    }, _callee24);
  }));

  return function scrollIntoView(_x22, _x23) {
    return _ref7.apply(this, arguments);
  };
}();

exports.scrollIntoView = scrollIntoView;